import { render, staticRenderFns } from "./ProjectDocumentList.vue?vue&type=template&id=3bd36e54&scoped=true"
import script from "./ProjectDocumentList.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentList.vue?vue&type=script&lang=js"
import style0 from "./ProjectDocumentList.vue?vue&type=style&index=0&id=3bd36e54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd36e54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd36e54')) {
      api.createRecord('3bd36e54', component.options)
    } else {
      api.reload('3bd36e54', component.options)
    }
    module.hot.accept("./ProjectDocumentList.vue?vue&type=template&id=3bd36e54&scoped=true", function () {
      api.rerender('3bd36e54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectInfo/ProjectDocumentList.vue"
export default component.exports